var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73792 0.698242H8.9284C10.331 0.698242 11.4681 1.8353 11.4681 3.23792V13.4744C11.4681 14.1758 10.8996 14.7443 10.1982 14.7443C9.90987 14.7443 9.63008 14.6461 9.40491 14.466L5.83316 11.6082L2.26141 14.466C1.7138 14.9041 0.914697 14.8154 0.476555 14.2678C0.296395 14.0426 0.198242 13.7628 0.198242 13.4744V3.23792C0.198242 1.8353 1.3353 0.698242 2.73792 0.698242ZM2.73792 1.96808C2.03661 1.96808 1.46808 2.53661 1.46808 3.23792V13.4744L5.03984 10.6167C5.50363 10.2456 6.1627 10.2456 6.62649 10.6167L10.1982 13.4744V3.23792C10.1982 2.53661 9.62971 1.96808 8.9284 1.96808H2.73792Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.1a4a5c40a267752e5f4be6adc4a70477.svg";
export { ForwardRef as ReactComponent };